module.exports = __webpack_public_path__ + "static/media/Datacycle.690e9508.png";